module.exports = __webpack_public_path__ + "img/critical_icon.f1526545.png";